module.exports = __webpack_public_path__ + "img/statusOn.3d82394b.png";